module.exports = __webpack_public_path__ + "media/images/icons/filled/api-8a30b765898638d628192aa431027dc0.svg";